import { StateCreator } from "zustand";
import { PaymentType } from "react-svg-credit-card-payment-icons";

export interface CreditCard {
  cardNumber: string;
  expiryDate: string;
  cvc: string;
  name: string;
  email: string;
  city: string;
  postalCode: string;
  street: string;
  state: string;
  countryIsoCode: string;
  type: PaymentType;
  id: string;
}

export type PaymentSlice = {
  paymentCards: CreditCard[];
  setPaymentCards: (cards: CreditCard[]) => void;
  deletePaymentCards: (accountId: string, cardId: string) => void;
};

export const paymentInitialState = {
  paymentCards: [
    {
      cardNumber: "4242424242424242",
      expiryDate: "12/24",
      cvc: "123",
      name: "Inseltic ApS",
      email: "inseltic@mail.com",
      city: "Berlin",
      postalCode: "10178",
      street: "Alexanderplatz 23",
      state: "Berlin",
      countryIsoCode: "dk",
      type: "Visa",
      id: "75427ff6-7d03-4600-baa5-1d2b7516ecad",
    },
    {
      cardNumber: "5105105105105105",
      expiryDate: "08/25",
      cvc: "456",
      name: "Alpha Corp",
      email: "alpha@example.com",
      city: "New York",
      postalCode: "10001",
      street: "123 Broadway",
      state: "NY",
      countryIsoCode: "us",
      type: "Mastercard",
      id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
    },
    {
      cardNumber: "3456345634563456",
      expiryDate: "05/23",
      cvc: "789",
      name: "Beta Ltd",
      email: "beta@example.com",
      city: "London",
      postalCode: "SW1A 0AA",
      street: "10 Downing Street",
      state: "England",
      countryIsoCode: "gb",
      type: "Amex",
      id: "fedcba98-7654-3210-fedc-ba9876543210",
    },
  ] as CreditCard[],
} as PaymentSlice;

export const createPaymentSlice: StateCreator<
  PaymentSlice,
  [],
  [],
  PaymentSlice
> = (set) =>
  ({
    ...paymentInitialState,
    setPaymentCards: (cards: CreditCard[]) => {
      set(() => {
        return {
          paymentCards: cards,
        };
      });
    },
    deletePaymentCards: (cardId: string) => {
      set(({ paymentCards }) => {
        const updatedCards = paymentCards?.filter((card) => card.id !== cardId);
        return {
          paymentCards: updatedCards,
        };
      });
    },
  } as PaymentSlice);
